class UserManualManager {
  constructor(productData, categoryData) {
    this.productData = productData;
    this.categoryData = categoryData;
    
    this.categoryBtns = document.querySelectorAll('.tree-category-btn');
    this.productBtns = document.querySelectorAll('.tree-product-btn');
    // this.contentTitle = document.getElementById('content-title');
    // this.contentDesc = document.getElementById('content-desc');
    this.documentsContainer = document.getElementById('documents-container');
    
    this._setupEventListeners();
  }

  getNoItemsImage() {
    return (window.theme && theme.assets && theme.assets.noItemsImage)
      ? theme.assets.noItemsImage
      : '/cdn/shop/t/13/assets/no-items.png?v=100137839757008554921772875367';
  }

  _setupEventListeners() {
    // 分类点击事件
    this.categoryBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this._handleCategoryClick(btn);
      });
    });

    // 产品点击事件
    this.productBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        this._handleProductClick(btn);
      });
    });
  }

  _handleCategoryClick(btn) {
    const category = btn.dataset.category;
    const hasProducts = parseInt(btn.dataset.hasProducts) > 0;
    const productsContainer = btn.nextElementSibling;
    
    // 切换展开状态
    const isExpanded = btn.classList.contains('expanded');
    
    // 关闭所有其他分类
    this.categoryBtns.forEach(b => {
      b.classList.remove('expanded', 'active');
      const container = b.nextElementSibling;
      if (container) container.classList.remove('expanded');
    });
    this.productBtns.forEach(b => b.classList.remove('active'));
    
    if (!isExpanded) {
      btn.classList.add('expanded', 'active');
      if (productsContainer) {
        productsContainer.classList.add('expanded');
      }
      
      // 显示该分类下所有产品的文档
      const productIds = this._getCategoryProductIds(category);
      this._renderDocuments(
        productIds,
        this.categoryData[category].title,
        `显示 ${this.categoryData[category].title} 分类下的所有文档`
      );
    } 
    // else {
    //   // 折叠后显示所有文档
    //   this._renderDocuments(
    //     this._getAllProductIds(),
    //     '所有产品文档',
    //     '显示所有分类下的用户手册文档'
    //   );
    // }
  }

  _handleProductClick(btn) {
    const productId = btn.dataset.productId;
    const category = btn.dataset.category;
    const product = this.productData[productId];
    
    // 激活状态
    this.productBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    
    // 显示单个产品的文档
    if (product && product.manuals.length > 0) {
      this._renderDocuments(
        [productId],
        product.title,
        `${this.categoryData[category].title} → ${product.title}`
      );
    } else {
      // this.contentTitle.textContent = product.title;
      // this.contentDesc.textContent = '该产品暂无文档';
      const noItemsImage = this.getNoItemsImage();
      this.documentsContainer.innerHTML = `
        <div class="empty-state" style="grid-column: 1 / -1;">
          <img src="${noItemsImage}" alt="" />
        </div>
      `;
    }
  }

  _renderDocuments(productIds, title, description) {
    // this.contentTitle.textContent = title;
    // this.contentDesc.textContent = description;
    
    const noItemsImage = this.getNoItemsImage();
    const cards = [];
    productIds.forEach(pid => {
      const product = this.productData[pid];
      if (!product || !product.manuals.length) return;
      
      product.manuals.forEach(manual => {
        // 从 URL 中提取文件名
        const fileStr = manual.url.split('/').pop();
        const fileName = fileStr.split('?')[0];
        
        cards.push(`
          <a href="${manual.url}" target="_blank" class="document-card" data-product-id="${product.id}" data-category="${product.category}">
            <svg class="icon document-icon inline-block" t="1769507509236" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7866">
              <path d="M832 384h-256V128H192v768h640V384z m-25.984-64L640 153.984V320h166.016zM160 64h480l256 256v608q0 14.016-8.992 23.008T864 960H160q-14.016 0-23.008-8.992T128 928V96q0-14.016 8.992-23.008T160 64z m160 448h384v64H320v-64z m0-192h160v64h-160v-64z m0 384h384v64H320v-64z" p-id="7867" fill="#666"></path>
            </svg>
            <div class="doc-info">
              <div class="doc-name">${fileName}</div>
            </div>
            <div class="doc-actions">
              <div class="doc-btn view flex items-center justify-center gap-1" target="_blank">
                <svg class="icon download-icon inline-block" t="1769419406246" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6633">
                  <path d="M796.444444 682.666667v113.777777h-568.888888V682.666667a28.444444 28.444444 0 0 0-56.888889 0v113.777777a56.888889 56.888889 0 0 0 56.888889 56.888889h568.888888a56.888889 56.888889 0 0 0 56.888889-56.888889V682.666667a28.444444 28.444444 0 1 0-56.888889 0z" fill="#00a5df" p-id="6634"></path>
                  <path d="M483.555556 170.666667m28.444444 0l0 0q28.444444 0 28.444444 28.444444l0 455.111111q0 28.444444-28.444444 28.444445l0 0q-28.444444 0-28.444444-28.444445l0-455.111111q0-28.444444 28.444444-28.444444Z" fill="#00a5df" p-id="6635"></path>
                  <path d="M511.203556 729.770667a28.330667 28.330667 0 0 1-20.138667-8.305778L330.183111 560.583111a28.444444 28.444444 0 0 1 40.220445-40.277333l140.8 140.8L651.946667 520.305778a28.444444 28.444444 0 1 1 40.277333 40.277333L531.285333 721.464889a28.330667 28.330667 0 0 1-20.081777 8.305778z" fill="#00a5df" p-id="6636"></path>
                </svg>
                PDF
              </div>
            </div>
          </a>
        `);
      });
    });
    
    if (cards.length === 0) {
      this.documentsContainer.innerHTML = `
        <div class="empty-state">
          <img src="${noItemsImage}" alt="" />
        </div>
      `;
    } else {
      this.documentsContainer.innerHTML = cards.join('');
    }
  }

  _getAllProductIds() {
    return Object.keys(this.productData);
  }

  _getCategoryProductIds(categoryHandle) {
    return this.categoryData[categoryHandle]?.products || [];
  }
}

// 初始化函数增加容错
function initUserManual(productData, categoryData) {
  // 强制转为对象，避免非对象参数
  const safeProductData = Object.prototype.toString.call(productData) === '[object Object]' ? productData : {};
  const safeCategoryData = Object.prototype.toString.call(categoryData) === '[object Object]' ? categoryData : {};
  return new UserManualManager(safeProductData, safeCategoryData);
}
